export default {
  app: {
    title: 'Giác Ngộ',
    description: 'Khám phá Giác Ngộ (Abhidhamma) qua các sơ đồ trực quan, dễ hiểu và tương tác.'
  },
  nav: {
    home: 'Trang chủ',
    catalog: 'Danh mục Sơ đồ',
    about: 'Giới thiệu',
    contact: 'Liên hệ'
  },
  header: {
    home: 'Trang chủ',
    learning_paths: 'Lộ trình học tập'
  },
  home: {
    hero: {
      title: 'Học Phật qua sơ đồ trực quan',
      subtitle: 'Hiểu sâu hơn về Tâm, Tâm sở và Sắc pháp thông qua các sơ đồ tương tác, dễ hiểu và trực quan.',
      description: 'Khám phá kho tàng kiến thức Phật giáo qua các khóa học và sơ đồ trực quan',
      exploreCourses: 'Khám phá khóa học',
      exploreDiagrams: 'Khám phá sơ đồ',
      exploreButton: 'Khám phá sơ đồ',
      learnMoreButton: 'Tìm hiểu thêm',
      imageAlt: 'Minh họa Giác Ngộ'
    },
    features: {
      title: 'Tính năng nổi bật',
      subtitle: 'Ứng dụng Giác Ngộ cung cấp nhiều tính năng giúp bạn dễ dàng tiếp cận và hiểu sâu về Giác Ngộ.',
      feature1: {
        title: 'Sơ đồ tương tác',
        description: 'Tương tác với sơ đồ bằng cách phóng to, thu nhỏ, di chuyển và click vào các node để xem thông tin chi tiết.'
      },
      feature2: {
        title: 'Tìm kiếm nâng cao',
        description: 'Tìm kiếm nhanh chóng các khái niệm trong sơ đồ và xem kết quả được highlight trực tiếp.'
      },
      feature3: {
        title: 'Đa nền tảng',
        description: 'Trải nghiệm mượt mà trên mọi thiết bị: máy tính, tablet và điện thoại di động.'
      },
      feature4: {
        title: 'Chế độ tối/sáng',
        description: 'Tùy chỉnh giao diện với chế độ tối hoặc sáng để bảo vệ mắt và tăng trải nghiệm người dùng.'
      }
    },
    userWidget: {
      welcome: 'Chào mừng trở lại',
      loginTitle: 'Đăng nhập',
      loginPrompt: 'Đăng nhập để truy cập các khóa học và sơ đồ',
      loginButton: 'Đăng nhập',
      registerButton: 'Đăng ký'
    },
    popularDiagrams: {
      title: 'Sơ đồ phổ biến',
      subtitle: 'Khám phá những sơ đồ Giác Ngộ được nhiều người quan tâm nhất.',
      viewAllButton: 'Xem tất cả sơ đồ'
    },
    aboutAbhidhamma: {
      title: 'Giới thiệu về Giác Ngộ',
      description1: 'Giác Ngộ (Abhidhamma) là phần giáo lý sâu sắc trong Phật giáo, phân tích chi tiết về tâm, tâm sở và sắc pháp, giúp hiểu rõ bản chất của thực tại.',
      description2: 'Ứng dụng Giác Ngộ giúp đơn giản hóa những khái niệm phức tạp này thông qua các sơ đồ trực quan, giúp người học dễ dàng tiếp cận và áp dụng vào đời sống hàng ngày.',
      learnMoreButton: 'Tìm hiểu thêm',
      imageAlt: 'Minh họa về Giác Ngộ'
    },
    contact: {
      title: 'Liên hệ với chúng tôi',
      subtitle: 'Có câu hỏi hoặc góp ý? Hãy liên hệ với chúng tôi qua các kênh sau.',
      email: {
        title: 'Email',
        description: 'contact@giacngo.org'
      },
      social: {
        title: 'Mạng xã hội',
        description: 'Theo dõi chúng tôi trên Facebook, Twitter và Instagram.'
      },
      resources: {
        title: 'Tài nguyên',
        description: 'Truy cập thư viện tài liệu và video hướng dẫn.'
      }
    }
  },
  catalog: {
    title: 'Danh mục sơ đồ Phật giáo',
    subtitle: 'Khám phá các sơ đồ Phật giáo được phân loại theo chủ đề và mức độ khó.',
    search: 'Tìm kiếm sơ đồ...',
    categories: 'Danh mục',
    difficulty: 'Mức độ khó',
    tags: 'Tags',
    resetFilters: 'Xóa bộ lọc',
    diagrams: 'sơ đồ',
    sort: 'Sắp xếp:',
    sortOptions: {
      newest: 'Mới nhất',
      oldest: 'Cũ nhất',
      aToZ: 'A-Z',
      zToA: 'Z-A'
    },
    categoryOptions: {
      thangPhap: 'Giác Ngộ (Abhidhamma)',
      sutras: 'Kinh điển',
      meditation: 'Thiền định',
      philosophy: 'Triết học Phật giáo',
      history: 'Lịch sử Phật giáo',
      practice: 'Thực hành'
    },
    difficultyOptions: {
      beginner: 'Sơ cấp',
      intermediate: 'Trung cấp',
      advanced: 'Cao cấp',
      all: 'Tất cả'
    }
  },
  diagrams: {
    citta: {
      title: 'Sơ đồ Tâm (Citta)',
      shortDescription: 'Khám phá 89/121 loại tâm và mối quan hệ giữa chúng.'
    },
    cetasika: {
      title: 'Sơ đồ Tâm sở (Cetasika)',
      shortDescription: 'Tìm hiểu về 52 tâm sở và cách chúng kết hợp với các loại tâm.'
    },
    rupa: {
      title: 'Sơ đồ Sắc pháp (Rūpa)',
      shortDescription: 'Khám phá 28 loại sắc pháp và cách chúng được phân loại.'
    },
    fourNobleTruths: 'Tứ Diệu Đế',
    eightfoldPath: 'Bát Chánh Đạo',
    dependentOrigination: 'Thập Nhị Nhân Duyên',
    fiveAggregates: 'Ngũ Uẩn',
    threeMarks: 'Tam Tướng',
    backToCatalog: 'Quay lại danh mục',
    viewModes: {
      mindmap: 'Sơ đồ tư duy',
      tree: 'Cây phân cấp',
      radial: 'Hình tròn'
    },
    controls: {
      zoomIn: 'Phóng to',
      zoomOut: 'Thu nhỏ',
      reset: 'Đặt lại',
      search: 'Tìm kiếm trong sơ đồ...'
    },
    legend: 'Chú thích',
    details: 'Thông tin chi tiết'
  },
  diagram: {
    viewModes: {
      mindmap: 'Sơ đồ tư duy',
      tree: 'Cây phân cấp',
      radial: 'Hình tròn'
    },
    resetView: 'Đặt lại',
    export: 'Xuất',
    searchPlaceholder: 'Tìm kiếm trong sơ đồ...',
    errorLoading: 'Lỗi khi tải dữ liệu',
    tryAgain: 'Vui lòng thử lại sau',
    description: 'Mô tả',
    details: 'Chi tiết',
    children: 'Các thành phần con',
    nodeDetailsTip: 'Bạn vẫn có thể xem thông tin chi tiết trong khi đang ở chế độ làm nổi bật luồng.',
    nodeTypes: {
      root: 'Gốc',
      kamavacara: 'Dục giới',
      rupavacara: 'Sắc giới',
      arupavacara: 'Vô sắc giới',
      lokuttara: 'Siêu thế',
      akusala: 'Bất thiện',
      ahetuka: 'Vô nhân',
      sobhana: 'Tịnh hảo',
    },
    classificationBasis: 'Cơ sở phân loại',
    benefits: 'Lợi ích',
    subCategories: 'Danh mục con',
    tabs: {
      diagram: 'Sơ đồ',
      info: 'Thông tin'
    },
    mindmap: 'Sơ đồ tư duy',
    tree: 'Cây phân cấp',
    radial: 'Hình tròn',
    horizontal: 'Luồng ngang',
    reset: 'Đặt lại',
    fullscreen: 'Toàn màn hình',
    exitFullscreen: 'Thoát toàn màn hình',
    legendAndTips: 'Chú thích và mẹo sử dụng',
    shortcuts: 'Phím tắt',
    askAboutNode: 'Hỏi về khái niệm này',
    tips: {
      title: 'Mẹo sử dụng',
      zoom: 'Cuộn chuột để phóng to/thu nhỏ',
      pan: 'Kéo thả để di chuyển sơ đồ',
      click: 'Click vào node để xem thông tin chi tiết',
      viewMode: 'Chuyển đổi giữa các chế độ xem khác nhau',
      fullscreen: 'Sử dụng chế độ toàn màn hình để xem sơ đồ rõ hơn'
    },
    shortcuts: {
      zoom: 'Phóng to/thu nhỏ',
      collapse: 'Thu gọn/mở rộng node',
      fit: 'Vừa khít sơ đồ',
      exitFullscreen: 'Thoát chế độ toàn màn hình'
    },
    legend: {
      title: 'Chú thích màu sắc',
      root: 'Gốc',
      rootDesc: 'Nút gốc của sơ đồ',
      kamavacara: 'Dục giới',
      kamavacaraDesc: 'Tâm thuộc dục giới',
      rupavacara: 'Sắc giới',
      rupavacaraDesc: 'Tâm thuộc sắc giới',
      arupavacara: 'Vô sắc giới',
      arupavacaraDesc: 'Tâm thuộc vô sắc giới',
      lokuttara: 'Siêu thế',
      lokuttaraDesc: 'Tâm siêu thế',
      akusala: 'Bất thiện',
      akusalaDesc: 'Tâm bất thiện',
      akusalaCetasikaDesc: 'Tâm sở bất thiện',
      ahetuka: 'Vô nhân',
      ahetukaDesc: 'Tâm vô nhân',
      sobhana: 'Tịnh hảo',
      sobhanaDesc: 'Tâm tịnh hảo',
      sobhanaCetasikaDesc: 'Tâm sở tịnh hảo',
      annasamana: 'Biến hành',
      annasamanaDesc: 'Tâm sở biến hành',
      mahabhuta: 'Đại hiển',
      mahabhutaDesc: 'Sắc đại hiển',
      upada: 'Y đại sinh',
      upadaDesc: 'Sắc y đại sinh',
      pasada: 'Thần kinh',
      pasadaDesc: 'Sắc thần kinh',
      gocara: 'Cảnh',
      gocaraDesc: 'Sắc cảnh',
      bhava: 'Tính',
      bhavaDesc: 'Sắc tính',
      hadaya: 'Ý vật',
      hadayaDesc: 'Sắc ý vật',
      jivita: 'Mạng căn',
      jivitaDesc: 'Sắc mạng căn',
      ahara: 'Vật thực',
      aharaDesc: 'Sắc vật thực',
      
      // Chú thích cho Tứ Diệu Đế
      fourNobleTruths: {
        dukkha: 'Khổ Đế',
        dukkhaDesc: 'Chân lý về khổ đau',
        samudaya: 'Tập Đế',
        samudayaDesc: 'Chân lý về nguyên nhân của khổ đau',
        nirodha: 'Diệt Đế',
        nirodhaDesc: 'Chân lý về sự chấm dứt khổ đau',
        magga: 'Đạo Đế',
        maggaDesc: 'Chân lý về con đường dẫn đến chấm dứt khổ đau'
      },
      
      // Chú thích cho Bát Chánh Đạo
      eightfoldPath: {
        rightView: 'Chánh kiến',
        rightViewDesc: 'Hiểu biết đúng đắn về Tứ Diệu Đế',
        rightIntention: 'Chánh tư duy',
        rightIntentionDesc: 'Suy nghĩ đúng đắn, không tham, sân, hại',
        rightSpeech: 'Chánh ngữ',
        rightSpeechDesc: 'Lời nói đúng đắn, không nói dối, nói chia rẽ, nói thô ác, nói vô ích',
        rightAction: 'Chánh nghiệp',
        rightActionDesc: 'Hành động đúng đắn, không sát sinh, trộm cắp, tà dâm',
        rightLivelihood: 'Chánh mạng',
        rightLivelihoodDesc: 'Sinh kế đúng đắn, không làm các nghề gây hại',
        rightEffort: 'Chánh tinh tấn',
        rightEffortDesc: 'Nỗ lực đúng đắn trong việc tu tập',
        rightMindfulness: 'Chánh niệm',
        rightMindfulnessDesc: 'Tỉnh giác đúng đắn về thân, thọ, tâm, pháp',
        rightConcentration: 'Chánh định',
        rightConcentrationDesc: 'Tập trung tâm ý đúng đắn'
      },
      
      // Chú thích cho Thập Nhị Nhân Duyên
      dependentOrigination: {
        ignorance: 'Vô minh',
        ignoranceDesc: 'Không hiểu biết về Tứ Diệu Đế',
        formations: 'Hành',
        formationsDesc: 'Các hoạt động có chủ ý',
        consciousness: 'Thức',
        consciousnessDesc: 'Nhận thức',
        nameForm: 'Danh sắc',
        nameFormDesc: 'Tâm và thân',
        sixSenses: 'Lục nhập',
        sixSensesDesc: 'Sáu cơ quan cảm giác',
        contact: 'Xúc',
        contactDesc: 'Tiếp xúc giữa giác quan và đối tượng',
        feeling: 'Thọ',
        feelingDesc: 'Cảm giác',
        craving: 'Ái',
        cravingDesc: 'Ham muốn',
        clinging: 'Thủ',
        clingingDesc: 'Bám víu',
        becoming: 'Hữu',
        becomingDesc: 'Quá trình trở thành',
        birth: 'Sinh',
        birthDesc: 'Tái sinh',
        agingDeath: 'Lão tử',
        agingDeathDesc: 'Già và chết'
      },
      
      // Chú thích cho Ngũ Uẩn
      fiveAggregates: {
        form: 'Sắc uẩn',
        formDesc: 'Vật chất, thân thể',
        feeling: 'Thọ uẩn',
        feelingDesc: 'Cảm giác',
        perception: 'Tưởng uẩn',
        perceptionDesc: 'Nhận thức',
        mentalFormations: 'Hành uẩn',
        mentalFormationsDesc: 'Các hoạt động tâm lý',
        consciousness: 'Thức uẩn',
        consciousnessDesc: 'Nhận thức'
      },
      
      // Chú thích cho Tam Tướng
      threeMarks: {
        impermanence: 'Vô thường',
        impermanenceDesc: 'Tính chất không thường hằng của mọi hiện tượng',
        suffering: 'Khổ',
        sufferingDesc: 'Tính chất không thỏa mãn của mọi hiện tượng',
        nonSelf: 'Vô ngã',
        nonSelfDesc: 'Tính chất không có bản ngã của mọi hiện tượng'
      }
    },
    diagram: 'Sơ đồ',
    information: 'Thông tin',
    introduction: 'Giới thiệu',
    conclusion: 'Kết luận',
    category: 'Danh mục',
    subcategory: 'Danh mục con',
    item: 'Mục',
    legend: 'Chú thích',
    tips: 'Mẹo sử dụng',
    tipZoom: 'Cuộn chuột để phóng to/thu nhỏ',
    tipPan: 'Kéo thả để di chuyển sơ đồ',
    tipClick: 'Click vào node để xem thông tin chi tiết',
    shortcutZoom: 'Phóng to/thu nhỏ',
    shortcutPan: 'Di chuyển sơ đồ',
    shortcutReset: 'Đặt lại sơ đồ',
    search: 'Tìm kiếm',
    enableHighlight: 'Bật làm nổi bật luồng',
    disableHighlight: 'Tắt làm nổi bật luồng',
    hideAllEdges: 'Ẩn tất cả đường kết nối',
    showAllEdges: 'Hiện tất cả đường kết nối',
    exportPdf: 'Xuất PDF',
    exporting: 'Đang xuất PDF...',
    exportError: 'Có lỗi khi xuất PDF',
    content: 'Nội dung',
    terms: 'Thuật ngữ',
    examples: 'Ví dụ',
    references: 'Tài liệu tham khảo',
    relatedConcepts: 'Khái niệm liên quan'
  },
  lessons: {
    title: 'Bài học Phật học',
    subtitle: 'Khám phá các bài học Phật học được phân loại theo trình độ.',
    levels: {
      beginner: 'Sơ cấp',
      intermediate: 'Trung cấp',
      advanced: 'Cao cấp'
    },
    readMore: 'Đọc tiếp',
    relatedDiagrams: 'Sơ đồ liên quan',
    viewLesson: 'Xem bài học'
  },
  footer: {
    links: 'Liên kết',
    mainDiagrams: 'Sơ đồ chính',
    connect: 'Kết nối',
    copyright: 'Tất cả các quyền được bảo lưu.'
  },
  common: {
    loading: 'Đang tải...',
    error: 'Đã xảy ra lỗi',
    retry: 'Thử lại',
    notFound: 'Không tìm thấy',
    notFoundMessage: 'Trang bạn đang tìm kiếm không tồn tại.',
    backToHome: 'Quay lại trang chủ',
    search: 'Tìm kiếm',
    filter_by_tags: 'Lọc theo thẻ',
    clear_all: 'Xóa tất cả',
    explore: 'Khám phá',
    back_to_list: 'Quay lại danh sách',
    submit: 'Gửi',
    cancel: 'Hủy',
    save: 'Lưu',
    delete: 'Xóa',
    edit: 'Chỉnh sửa',
    add: 'Thêm',
    remove: 'Xóa',
    close: 'Đóng',
    open: 'Mở',
    show: 'Hiển thị',
    hide: 'Ẩn',
    expand: 'Mở rộng',
    collapse: 'Thu gọn',
    next: 'Tiếp theo',
    previous: 'Trước đó',
    first: 'Đầu tiên',
    last: 'Cuối cùng',
    all: 'Tất cả',
    none: 'Không có',
    yes: 'Có',
    no: 'Không',
    on: 'Bật',
    off: 'Tắt',
    enabled: 'Đã bật',
    disabled: 'Đã tắt',
    success: 'Thành công',
    failure: 'Thất bại',
    warning: 'Cảnh báo',
    info: 'Thông tin',
    reset: 'Đặt lại',
    collapse_info: 'Thu gọn thông tin',
    expand_info: 'Mở rộng thông tin',
    hide_info: 'Ẩn thông tin',
    show_info: 'Hiện thông tin',
    search_in_diagram: 'Tìm kiếm trong sơ đồ...'
  },
  difficulty: {
    beginner: 'Sơ cấp',
    intermediate: 'Trung cấp',
    advanced: 'Cao cấp'
  },
  ai: {
    chat_page_title: 'Trò chuyện với AI Phật học',
    chat_widget_title: 'Thiền Sư AI',
    type_message: 'Nhập tin nhắn của con...',
    send: 'Gửi',
    clear_conversation: 'Xóa lịch sử trò chuyện',
    open_chat: 'Mở trò chuyện',
    close_chat: 'Đóng trò chuyện',
    rate_limit_message: 'Con đã đạt đến số lượng tin nhắn tối đa cho giờ này. Vui lòng thử lại sau.',
    rate_limit_exceeded: 'Đã đạt giới hạn tin nhắn cho giờ này. Vui lòng thử lại sau.',
    cooldown_message: 'Vui lòng đợi {{seconds}} giây trước khi gửi tin nhắn tiếp theo.',
    please_wait: 'Vui lòng đợi {{seconds}} giây trước khi gửi tin nhắn tiếp theo.',
    fullpage_mode: 'Toàn trang',
    widget_mode: 'Chế độ Widget',
    show_widget: 'Hiện Widget Trò chuyện',
    hide_widget: 'Ẩn Widget Trò chuyện',
    widget_description: 'Widget trò chuyện cho phép con tương tác với Thiền Sư AI trong khi duyệt các trang khác.',
    chat_about_this: 'Hỏi về nội dung này',
    chat_intro: 'Con có thắc mắc về "{{contextName}}"? Hãy hỏi Thiền Sư AI!',
    chat_about_diagram: 'Trò chuyện về sơ đồ:',
    chat_about_lesson: 'Trò chuyện về bài học:'
  }
}
